import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from './login.module.css'

const baseURL = `${process.env.REACT_APP_API_URL}`


const Login = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLoginInputChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    }

    const handleLoginInputSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage('')

        try {
            const response = await fetch(`${baseURL}/accounts/login/`, {
                method: 'POST',
                headers: {
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();
            console.log('login data:', data)
            if (response.ok && data.success) {
                localStorage.setItem('accessToken', data.accessToken);
                localStorage.setItem('refreshToken', data.refresh);
                localStorage.setItem('accessExpiry', data.access_expiry);
                localStorage.setItem('email', formData.email);
                localStorage.setItem('username', data.username);
                localStorage.setItem('userId', data.user_id)

                console.log('Access token:', data.accessToken)
                navigate('/')
            } else {
                setErrorMessage(data.errors ? data.errors.non_field_errors || 'Invalid credential' : 'An error occured')
            }
        } catch (error) {
            setErrorMessage('Something went wrong, Please try again')
        } finally {
            setLoading(false)
        }
    }
    return (
        <div className={styles.loginContainer}>
            <h2>Login</h2>
            {errorMessage && <p className={styles.loginError}>{errorMessage}</p>}
            <form onSubmit={handleLoginInputSubmit}>
                <label>
                    Email:
                    <input 
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleLoginInputChange}
                        required
                    />
                </label>
                <label>
                    Password:
                    <input 
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleLoginInputChange}
                        required
                    />
                </label>
                <button type="submit" disabled={loading}>
                    {loading ? 'Loggin in...' : 'Login'}
                </button>
            </form>
        </div>
    );
};

export default Login;